export const init = () => {
  /* SHOPPING TOOL - INTERNAL SEARCH */

  const fwk = CUBE.Analytics;
  const lock = AnalyticsConstants.shoppingtool.lock;

  const stType = 'internal-search';

  // CSS Selectors for the differents Typeahead elements
  const typeahead = '.twitter-typeahead';
  const selectorInput = '#search-autocomplete';
  const selectorBtn = '#search-button';
  const selectorSuggestion = 'a';
  const searchForm = '.anly-search';

  if (!document.querySelector(selectorInput)) return;

  // KEYDOWN - Manual search
  if (document.querySelector(selectorInput)) {
    document.querySelector(selectorInput).addEventListener('keydown', e => {
      if (e.keyCode === 13) {
        if (lock.search)
          fwk.shoppingtool.set(
            `${stType}-autocompletion`,
            e.target.value.trim()
          );
        else fwk.shoppingtool.set(`${stType}-standard`, e.target.value.trim());
      } else if (e.keyCode > 27) lock.search = false;
    });
  }

  // CLICK on 'search' button
  if (document.querySelector(selectorBtn)) {
    document.querySelector(selectorBtn).addEventListener('click', e => {
      if (e.target.closest('form')) {
        fwk.shoppingtool.set(
          `${stType}-standard`,
          e.target
            .closest('form')
            .querySelector(selectorInput)
            .value.trim()
        );
      }
    });
  }

  // CLICK on suggestion
  const form = document.querySelector(searchForm);
  if (form) {
    form.addEventListener('click', e => {
      // $(typeahead).on('click.st', selectorSuggestion, function(e) {
      const element = e.target.closest('a');
      if (
        Array.from(document.querySelectorAll(selectorSuggestion)).indexOf(
          element
        ) < 0
      )
        return;

      if (element && element.closest('ul')) {
        if (
          element.closest('ul').classList.contains('search__result__products')
        ) {
          // Click on PRODUCT
          fwk.shoppingtool.set(
            `${stType}-autocompletion-product`,
            element.dataset.id
          );
        } else if (
          element.closest('ul').classList.contains('search__result__pages')
        ) {
          // Click on CATEGORY
          if (element.classList.contains('tt-empty')) {
            // EMPTY (standard search)
            fwk.shoppingtool.set(
              `${stType}-standard`,
              element.querySelector('strong').textContent.trim()
            );
          } else {
            // NOT EMPTY
            fwk.shoppingtool.set(
              `${stType}-autocompletion-category`,
              element.textContent.trim()
            );
          }
        }
      }
    });
  }

  // EVENT : Select a suggestion (autocomplete)
  $(typeahead).on('typeahead:autocomplete', () => {
    lock.search = true;
  });
  $(typeahead).on('typeahead:select', () => {
    lock.search = true;
  });
  // Note : "lock.search = true" = the current research is made by an autocompletion
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-internal-search.js